import React from 'react';
import { Link } from 'react-router-dom';
import { Bookmark, Trash2, MapPin, Building2, Bell } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import { useWatchlist } from '../context/WatchlistContext';

export default function WatchlistPage() {
  const { items, toggle, clear } = useWatchlist();

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="max-w-[1100px] mx-auto px-6 lg:px-10 pt-8 pb-10">
        <Breadcrumb items={[{ label: 'Home', to: '/' }, { label: 'Watchlist' }]} />

        <div className="mt-8 flex items-end justify-between flex-wrap gap-4">
          <div>
            <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#4A7C5E]"><Bookmark size={12}/> Your watchlist</div>
            <h1 className="mt-3 font-display text-5xl text-[#1A2622] leading-tight">Saved <span className="italic">{items.length}</span></h1>
            <p className="mt-3 text-[#3A4A44] max-w-xl">We'll email you when CMS publishes a new rating, citation, or ownership change on anything you're watching.</p>
          </div>
          {items.length > 0 && (
            <button onClick={clear} className="inline-flex items-center gap-1.5 px-4 h-10 rounded-full bg-white border border-[#E5DCC4] text-sm text-[#3A4A44] hover:border-[#C75D5D] hover:text-[#C75D5D]"><Trash2 size={14}/> Clear all</button>
          )}
        </div>

        {items.length === 0 ? (
          <div className="mt-10 rounded-3xl bg-white border border-dashed border-[#E5DCC4] p-12 text-center">
            <div className="mx-auto w-16 h-16 rounded-2xl bg-[#F5EFDD] flex items-center justify-center">
              <Bookmark size={24} className="text-[#4A7C5E]"/>
            </div>
            <h3 className="mt-5 font-display text-2xl text-[#1A2622]">Nothing saved yet</h3>
            <p className="mt-2 text-[#5A6660]">Browse facilities or owners and tap the bookmark icon to start tracking them.</p>
            <div className="mt-6 inline-flex gap-3">
              <Link to="/discover" className="px-5 h-11 inline-flex items-center rounded-full bg-[#1A2622] text-[#FBF6EC] text-sm font-medium hover:bg-[#2D5F4F]">Discover facilities</Link>
              <Link to="/owners" className="px-5 h-11 inline-flex items-center rounded-full bg-white border border-[#E5DCC4] text-sm text-[#1A2622] hover:border-[#4A7C5E]">Browse owners</Link>
            </div>
          </div>
        ) : (
          <>
            <div className="mt-8 p-5 rounded-2xl bg-gradient-to-r from-[#F5EFDD] to-[#EAE0C5] border border-[#E5DCC4] flex items-center justify-between gap-4 flex-wrap">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-[#1A2622] text-[#FBF6EC] flex items-center justify-center"><Bell size={16}/></div>
                <div>
                  <div className="font-display text-base font-semibold text-[#1A2622]">Alerts on — we'll email you</div>
                  <div className="text-xs text-[#5A6660] mt-0.5">New ratings, citations, or ownership changes will trigger a notification</div>
                </div>
              </div>
              <Link to="/" className="text-sm text-[#2D5F4F] font-medium hover:text-[#1A2622]">Manage preferences</Link>
            </div>

            <ul className="mt-6 space-y-3">
              {items.map((it) => (
                <li key={it.id} className="flex items-center justify-between gap-3 px-5 py-4 rounded-2xl bg-white border border-[#E5DCC4] hover:border-[#4A7C5E] transition-colors">
                  <Link to={`/${it.kind === 'facility' ? 'facilities' : it.kind === 'owner' ? 'owners' : 'chains'}/${it.slug}`} className="flex items-center gap-4 min-w-0 flex-1">
                    <div className="w-11 h-11 rounded-xl bg-[#F5EFDD] flex items-center justify-center shrink-0">
                      {it.kind === 'facility' ? <Building2 size={18} className="text-[#4A7C5E]"/> : <Bookmark size={18} className="text-[#4A7C5E]"/>}
                    </div>
                    <div className="min-w-0">
                      <div className="font-display text-base font-semibold text-[#1A2622] truncate">{it.name}</div>
                      <div className="text-xs text-[#7A857F] mt-0.5 flex items-center gap-2 uppercase tracking-wider">
                        <span>{it.kind}</span>
                        {it.city && <span className="flex items-center gap-1"><MapPin size={10}/> {it.city}, {it.state}</span>}
                      </div>
                    </div>
                  </Link>
                  <button onClick={() => toggle({ kind: it.kind, slug: it.slug, name: it.name, city: it.city, state: it.state })} className="p-2 rounded-lg text-[#7A857F] hover:bg-[#FBF0EC] hover:text-[#C75D5D]"><Trash2 size={15}/></button>
                </li>
              ))}
            </ul>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
